import { Component, OnInit, Input } from '@angular/core';
import { MenuModulos } from './menu-modulos.model';

@Component({
  selector: 'menu-modulo',
  templateUrl: './menu-modulos.component.html',
  styleUrls: ['./menu-modulos.component.scss']
})
export class MenuModulosComponent implements OnInit {

  @Input('modulos') modulos: Array<MenuModulos> =[];

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/Disco D/Projetos/central-cliente/src/app/angular-base-ui/menu-modulos/menu-modulos.component.ts